import { useState } from 'react';
import { Image as SiteImage, RichText } from 'components/shared';
import useBackInStock from 'hooks/klaviyo/useBackInStock';
import Popup from '../popup';

const NotifyMePopup = ({
  t,
  title,
  article,
  onClose,
  variantId,
  productId,
  titleImage,
  submitCopy,
  isPopupOpen,
  notifyMePopupImage: image,
}) => {
  const [email, setEmail] = useState('');
  const [subscribeToNewsletter, setSubscribeToNewsletter] = useState(false);

  const { subscribe } = useBackInStock({
    variantId,
    productId,
  });

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await subscribe(email, subscribeToNewsletter);
    } catch {
      return;
    } finally {
      onClose();
    }
  };

  return (
    <Popup show={isPopupOpen} onClose={onClose}>
      <div className="flex h-[400px] max-w-[1050px] flex-col-reverse md:h-[650px] md:flex-row md:gap-[25px] lg:gap-[50px]">
        <SiteImage src={image} className="relative hidden w-full min-w-[45%] md:block" priority />
        <div className="flex h-full w-full flex-col justify-center gap-[20px] p-[20px] text-center md:pr-[80px] md:text-left">
          {titleImage && (
            <SiteImage
              src={titleImage}
              quality={100}
              priority
              layout="responsive"
              className="mx-auto mb-[15px] md:mx-0"
            />
          )}
          <h2 className=" font-nimbus-sans-extd-d text-[20px] font-bold uppercase leading-[90%] md:text-[35px]">
            {title}
          </h2>
          <div className="font-nimbus-sans-d text-[12px] leading-[1.4]">
            <RichText data={article} />
          </div>
          <form className="flex flex-col gap-[20px]" onSubmit={handleSubmit}>
            <input
              required
              className="input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <label
              htmlFor="subscribeToNewsletter"
              className="flex items-center font-nimbus-sans-d text-[12px] leading-[1.4]"
            >
              <input
                className="mr-[10px] mt-[-1.5px]"
                id="subscribeToNewsletter"
                type="checkbox"
                name="subscribeToNewsletter"
                onChange={e => setSubscribeToNewsletter(e.target.checked)}
              />
              <span className="leading-none">
                {t(
                  'Notify me - Newsletter opt-in',
                  'Subscribe me to the Denham newsletter for exclusive offers and updates.'
                )}
              </span>
            </label>

            <button className="button w-full" type="submit">
              {submitCopy}
            </button>
          </form>
        </div>
      </div>
    </Popup>
  );
};

export default NotifyMePopup;
